import { apiPostFetchAnnexedParams } from '../../api/Argentia/endpoints/procedures'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../model/serviceResponse'

export const fetchAnnexedParams = async (request: any): Promise<ServiceResponse<any>> => {
  return await apiPostFetchAnnexedParams(request)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
